import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';


export interface ShieldData {
  isInitiated: boolean;
  isShieldCalled: boolean;
  setting: {
    status: string;
    shield_type: string;
    minimum_score: number;
    minimum_amount: number;
  };
  txnData: {
    email: string;
    amount: number;
    txnPgwRef: string;
    providerCode: string;
    currencyCode: string;
    type: 'RELOAD' | 'SPEND';
  };
}

const initialState = {
  isInitiated: false,
  isShieldCalled: false,
  setting: {
    status: '',
    shield_type: '',
    minimum_score: 0,
    minimum_amount: 0,
  },
  txnData: {
    type: '',
    email: '',
    amount: 0,
    txnPgwRef: '',
    providerCode: '',
    currencyCode: '',
  }
};

export const ShieldStore = signalStore(
  {
    providedIn: 'root'
  },
  withState(initialState),
  withMethods(
    (store) => {
      return {
        setShield: (data: ShieldData) => patchState(store, () => data),
        
        setIsCalled: (isCalled: boolean) => {
          patchState(
            store, 
            (state) => {
              return {
                ...state,
                isShieldCalled: isCalled,
              };
            }
          );
        }
      };
    }
  )
);
